import { styled } from "@mui/system";
import { Alert as MuiAlert } from "@mui/material";

const Alert = styled(MuiAlert)(({ theme, severity }) => {
  let alertColor, alertBackgroundColor;
  switch (severity) {
    case "error":
      alertColor = "var(--error-white)";
      alertBackgroundColor = "var(--error-light)";
      break;
    case "success":
      alertColor = "var(--success-white)";
      alertBackgroundColor = "var(--success-light)";
      break;
    case "warning":
      alertColor = "var(--warning-white)";
      alertBackgroundColor = "var(--warning-light)";
      break;
    default:
      alertColor = "var(--warning-white)";
      alertBackgroundColor = "var(--warning-light)";
  }

  return {
    backgroundColor: alertBackgroundColor,
    color: alertColor,
    boxShadow: "none",
    "& .MuiAlert-icon": {
      color: alertColor,
    },
  };
});

export default Alert;
